import { ConvertedDutyCalculationValueSleepDuty } from 'components/admin-portal/Tables/CLA/DutyCalculationValueSleepDuty/types';
import { convertToInternal } from 'components/admin-portal/Tables/CLA/DutyCalculationValueSleepDuty/utils/utils';
import { isNil } from 'ramda';
import { useEffect, useState } from 'react';
import { queries } from 'RestAPIs/rapini';

const useGetRowData = (rowId?: number | null) => {
  const { data, isFetching } = queries.useGetDutyCalculationValueSleepDuties();
  const [convertedData, setConvertedData] =
    useState<ConvertedDutyCalculationValueSleepDuty>();

  useEffect(() => {
    if (!isNil(data)) {
      const value = data?.find(
        (d) => d.dutyCalculationValueSleepDutyId === rowId
      );
      setConvertedData(convertToInternal(value));
    }
  }, [data]);

  return { isFetching, convertedData };
};

export default useGetRowData;
